
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

type Language = 'fr' | 'en' | 'de';

interface LanguageContextType {
  language: Language;
  setLanguage: (language: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>('fr');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Component to sync language with route - must be inside BrowserRouter
export const LanguageRouteSync = () => {
  const location = useLocation();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (location.pathname.startsWith('/en') || location.pathname.startsWith('/new4-en')) {
      setLanguage('en');
    } else if (location.pathname.startsWith('/de')) {
      setLanguage('de');
    } else {
      setLanguage('fr');
    }
  }, [location.pathname, setLanguage]);

  return null;
};
